import { Tokens } from '~/utils/constants';
import PearlApiService from '~/composables/PearlApiService';
import { getCancelErrorMessage, modifyHistoryHashStatus, saveHashToLocalStorage } from '~/utils';
import { useWalletInfo, useWeb3ModalAccount, useWeb3ModalProvider } from '@web3modal/ethers/vue';
import { useMainStore } from '~/stores/mainStore';
import { computed } from 'vue';
import { useNuxtApp } from '#imports';

export default () => {
  const { t } = useI18n();
  const { apiUrl } = useEnvs();
  const { address } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider();
  const { walletInfo } = useWalletInfo();
  const store = useMainStore();
  const { claimReward } = useStakingMethods();
  const { claimMinedTokens } = useMineLicense();
  const { $errorHandler } = useNuxtApp();

  const isLoading = ref(false);
  const currentToken = computed(() => store.currentToken);

  async function claim() {
    if (!address.value || !walletProvider.value) {
      alert(t('appStatisticUnlockWalletAlert'));
      return;
    }

    try {
      isLoading.value = true;
      const receipt = currentToken.value === Tokens.pearl ? await claimReward() : await claimMinedTokens();

      if (!receipt?.hash) {
        return;
      }

      await PearlApiService.pushActivity(apiUrl, {
        address: address.value ?? '',
        transactionHash: receipt.hash,
        value: 0,
        type: 'REWARD_CLAIM'
      });
      saveHashToLocalStorage(t('notificationClaimReward'), receipt.hash);
      store.updateVersion();

      await receipt?.wait();
      store.updateVersion();

      modifyHistoryHashStatus(receipt.hash, 'Done');
      store.updateVersion();
    } catch (e: unknown) {
      if (walletInfo.value?.name) {
        const errorMessage = getCancelErrorMessage(e, walletInfo.value.name);
        $errorHandler(t('notificationFailedToUnlock') + t(errorMessage));
      }
    } finally {
      isLoading.value = false;
    }
  }

  return {
    claim,
    isLoading
  };
};
